import { graphql } from "@/gql";

export const PLANS_QUERY = graphql(`
  query PLANS_QUERY {
    plans {
      edges {
        node {
          id
          name
          isExternalBilling
          featureRapidsos
          marketingType
        }
      }
    }
  }
`);
